import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getCartDiscountRules = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.pageNumber) queryParams.append("pageNumber", params.pageNumber);
    if (params.itemPerPage) queryParams.append("itemPerPage", params.itemPerPage);
    if (params.vendorId) queryParams.append("vendorId", params.vendorId);
    
    const response = await internalApi.get({
      server: "api/v1/",
      path: `admin/cart-discount-rules?${queryParams.toString()}`,
    });
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};

export const getCartDiscountRuleById = async (id) => {
  try {
    const response = await internalApi.get({
      server: "api/v1/",
      path: `admin/cart-discount-rules/${id}`,
    });
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};

export const createCartDiscountRule = async (payload) => {
  try {
    const response = await internalApi.post(
      { server: "api/v1/", path: "admin/cart-discount-rules" },
      payload
    );
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};

export const updateCartDiscountRule = async (id, payload) => {
  try {
    const response = await internalApi.put(
      { server: "api/v1/", path: `admin/cart-discount-rules/${id}` },
      payload
    );
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};

export const deleteCartDiscountRule = async (id) => {
  try {
    const response = await internalApi.delete({
      server: "api/v1/",
      path: `admin/cart-discount-rules/${id}`,
    });
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};

export const toggleCartDiscountRuleStatus = async (id, isEnabled) => {
  try {
    const response = await internalApi.put(
      { server: "api/v1/", path: `admin/cart-discount-rules/${id}/toggle` },
      { isEnabled }
    );
    return response;
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};
